import { ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "@providers/UserProvider";
import { theme } from "../styles/theme";
import { toastContainerProps } from "../utils/toast";

type AppProvidersProps = {
  children: React.ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer {...toastContainerProps} />
      <UserProvider>{children}</UserProvider>
    </ThemeProvider>
  );
}
